import React, { FC, memo } from 'react';

import { TEXTS } from 'application/pages/PointsPage/renderer/texts';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import Info, { InfoTypes } from '@zvuk-b2b/react-uikit/ui/Info';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';

import { DATA_TEST_IDS } from '../consts';
import styles from './index.module.scss';
import { StreamUnbindModalComponentProps } from './types';
import useStreamUnbindModalViewModel from './useStreamUnbindModalViewModel';

const StreamUnbindModal: FC<StreamUnbindModalComponentProps> = ({ pointId, isStreamUnbindUnsupported, close }) => {
  const { handleClose, handleUnbind, isLoading } = useStreamUnbindModalViewModel({ pointId, close });

  return (
    <ModalScreen
      elementId={DATA_TEST_IDS.STREAM_UNBIND_MODAL}
      title={TEXTS.POINT_STREAM_UNBIND_MODAL_TITLE}
      titlePlacement="left"
      onClose={handleClose}
      actionButtons={[
        <Button
          key={DATA_TEST_IDS.STREAM_UNBIND_CONFIRM}
          elementId={DATA_TEST_IDS.STREAM_UNBIND_CONFIRM}
          type={ButtonType.PRIMARY}
          isLoading={isLoading}
          onClick={handleUnbind}>
          {TEXTS.POINT_STREAM_UNBIND_MODAL_BUTTON_CONFIRM}
        </Button>,
        <Button
          key={DATA_TEST_IDS.STREAM_UNBIND_CANCEL}
          elementId={DATA_TEST_IDS.STREAM_UNBIND_CANCEL}
          type={ButtonType.SECONDARY}
          isDisabled={isLoading}
          onClick={handleClose}>
          {TEXTS.POINT_STREAM_UNBIND_MODAL_BUTTON_CANCEL}
        </Button>,
      ]}>
      {TEXTS.POINT_STREAM_UNBIND_MODAL_DESCRIPTION}

      {isStreamUnbindUnsupported && (
        <Info
          className={styles.unsupportedPlayerWarning}
          elementId={DATA_TEST_IDS.STREAM_UNBIND_UNSUPPORTED_PLAYER_WARNING}
          type={InfoTypes.WARNING}>
          {TEXTS.POINT_STREAM_UNBIND_MODAL_UNSUPPORTED_PLAYER_WARNING}
        </Info>
      )}
    </ModalScreen>
  );
};

export default memo(StreamUnbindModal);
